import { select, subscribe } from '@wordpress/data';
import { store as blockEditorStore } from '@wordpress/block-editor';
import { SwiperInit } from './swiper-init';

export const subscribeSliderUpdate = (slider, clientId, element, options) => {
    return subscribe(() => {
        const currentSlidesOrder = select(blockEditorStore).getBlockOrder(clientId);
        const selectedBlock = select(blockEditorStore).getSelectedBlock();
        
        // Check if the slider has been changed.
        if (currentSlidesOrder.toString() !== currentSlidesOrder.toString()) {

            const slideAdded = currentSlidesOrder.length > currentSlidesOrder.length;
            const slideRemoved = currentSlidesOrder.length < currentSlidesOrder.length;
            const slideMoved = currentSlidesOrder.length === currentSlidesOrder.length;
            const activeIndex = slider?.activeIndex || 0;

            if (slideAdded || slideRemoved || slideMoved) {
                slider.destroy();
            }

            // Destroy and Reload the slider properly
            if (slideAdded || slideRemoved || slideMoved) {
                slider.destroy();  // Destroy existing instance
                slider = null;     // Ensure it's fully reset

                // 🛠 Reinitialize slider after a slight delay
                setTimeout(() => {
                    slider = SwiperInit(element, options);

                    // Determine where the slider should go.
                    let slideToIndex = activeIndex;
                    if (slideAdded) {
                        slideToIndex = currentSlidesOrder.length - 1; // Move to last slide
                    } else if (slideRemoved) {
                        slideToIndex = Math.max(activeIndex - 1, 0);
                    } 

                    slider.slideTo(slideToIndex, 0);
                }, 50);
            }
        }

        if (selectedBlock) {
            const isSlideSelected = currentSlidesOrder.includes(selectedBlock.clientId);
            if (slider && isSlideSelected) {
				try {
					slider.destroy(true, true);
				} catch (err) {}
				slider = null;
			}
        }
    });
};
